function filterAvailableInventories(startDate, endDate,inventories,duration) {
    const givenStartDate = new Date(startDate);
    const givenEndDate = new Date(endDate);

    function generateCampaignDurations(start, end, duration) {
        const results = [];
        const durationInDays = duration - 1; // Because we are counting the start day as well
        const current = new Date(start);
        
        while (current <= end) {
            let campaignEnd = new Date(current);
            campaignEnd.setDate(campaignEnd.getDate() + durationInDays);
            results.push({ start: new Date(current), end: campaignEnd });
            current.setDate(current.getDate() + 1);
        }

        return results;
    }

    const campaignDurations = generateCampaignDurations(givenStartDate, givenEndDate, duration);

    return inventories.filter(inventory => {
        return inventory.Bookings.every(booking => {
            const bookingStartDate = new Date(booking.startDate);
            const bookingEndDate = new Date(booking.endDate);

            // Check if the booking does not fall within any of the campaign durations
            return campaignDurations.some(duration => {
                return duration.end < bookingStartDate || duration.start > bookingEndDate;
            });
        });
    });
}

export default filterAvailableInventories;












//Old BackuP code
// function filterAvailableInventories(startDate, endDate, inventories) {
//     const givenStartDate = new Date(startDate);
//     const givenEndDate = new Date(endDate);

//     return inventories.filter(inventory => {
//         return inventory.Bookings.every(booking => {
//             const bookingStartDate = new Date(booking.startDate);
//             const bookingEndDate = new Date(booking.endDate);

//             // Check if the given date range is completely outside the booking date range
//             return givenEndDate < bookingStartDate || givenStartDate > bookingEndDate;
//         });
//     });
// }

// export default filterAvailableInventories;


//This amazing crazy function will provide you the amazing  filtered inventories......what else do you want amigo 🤗🤗
// The Inventories you pass in must have the following format ...the rest the function will take care 🤡🤡

// const inventories = [
//     {
//         inv: 23423,
//         Bookings: [
//             { startDate: "2024-05-14T00:00:00.000+00:00", endDate: "2024-05-20T00:00:00.000+00:00" },
//             { startDate: "2024-06-01T00:00:00.000+00:00", endDate: "2024-06-09T00:00:00.000+00:00" },
//             { startDate: "2024-06-21T00:00:00.000+00:00", endDate: "2024-06-24T00:00:00.000+00:00" }
//         ]
//     },
//     {
//         inv: 23342,
//         Bookings: [
//             { startDate: "2024-06-18T00:00:00.000+00:00", endDate: "2024-06-20T00:00:00.000+00:00" },
//             { startDate: "2024-06-25T00:00:00.000+00:00", endDate: "2024-06-29T00:00:00.000+00:00" }
//         ]
//     }
// ];